(()=>{

  window.addEventListener('DOMContentLoaded',async  () => {
    // URLにproductパラメータがある場合、お問い合わせフォームの商品名の欄を追加する
    const urlParams = new URLSearchParams(window.location.search);
    const product = urlParams.get('product');

    console.log({product})

    if (product) {

     const  title =  await fetch(window.Shopify.routes.root + `products/${product}.js`)
      .then(response => response.json())
      .then((product) => { return product.title });

      const productInput = document.createElement('input');
      productInput.type = 'text';
      productInput.name = 'contact[商品名]';
      productInput.value = title;
      const productRow = document.createElement('div');
      productRow.classList.add('contact-form__row');
      productRow.appendChild(productInput);

      // 一番上に追加
      document.querySelector('.contact-form form').prepend(productRow) ;
    }


  });

})();